// De Supabase-client, op één plek aangemaakt. De anon key mag publiek zijn,
// maar alleen zolang RLS op elke tabel aanstaat (zie docs/fase-0-audit.sql).
//
// De sleutel komt uit de build. Ontbreekt die (oude bundel, lokale test), dan
// valt de app terug op een eenmalig ingevoerde sleutel in localStorage.
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config.js';

const OPSLAG = 'sb_anon_key';
let client = null;

// Maakt de client en geeft hem terug, of null als er geen sleutel is.
// `supabase` is de globale van de CDN-bibliotheek in index.template.html.
export function maakClient() {
  const stored = localStorage.getItem(OPSLAG);
  const key = (SUPABASE_ANON_KEY && SUPABASE_ANON_KEY !== 'REPLACE_WITH_ANON_KEY')
    ? SUPABASE_ANON_KEY : stored;
  if (!key) return null;
  if (key !== stored) localStorage.setItem(OPSLAG, key);
  client = supabase.createClient(SUPABASE_URL, key);
  return client;
}

export function getClient() { return client; }

export function bewaarAnonKey(key) { localStorage.setItem(OPSLAG, key); }
